<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Club data edit modal title@@clubComponent.workspaceTitle.editFanScoreCard'>Edit Fan Score Card</h3>
    <form [formGroup]="clubForm" (ngSubmit)="updateClub()" id="editFanScoreCardForm">
      <div app-form-field-number
           [isCurrency]="false"
           [control]="clubForm.get('customerScoreConfiguration.merchandiseOrdersThreshold')"
           [placeholder]="customerScoreTranslations.i18nMerchQuantity"
           [label]="customerScoreTranslations.i18nMerchQuantity">
      </div>
      <div app-form-field-number
           [control]="clubForm.get('customerScoreConfiguration.merchandiseRevenueThreshold')"
           [placeholder]="customerScoreTranslations.i18nMerchRevenue"
           [label]="customerScoreTranslations.i18nMerchRevenue">
      </div>
      <div app-form-field-number
           [isCurrency]="false"
           [control]="clubForm.get('customerScoreConfiguration.ticketingOrdersThreshold')"
           [placeholder]="customerScoreTranslations.i18nTicketQuantity"
           [label]="customerScoreTranslations.i18nTicketQuantity">
      </div>
      <div app-form-field-number
           [control]="clubForm.get('customerScoreConfiguration.ticketingRevenueThreshold')"
           [placeholder]="customerScoreTranslations.i18nTicketRevenue"
           [label]="customerScoreTranslations.i18nTicketRevenue">
      </div>
      <div app-form-field-number
           [isCurrency]="false"
           [min]=1
           [max]=60
           [control]="clubForm.get('customerScoreConfiguration.timeframeInMonths')"
           [placeholder]="customerScoreTranslations.i18MonthsTimeFrame"
           [label]="customerScoreTranslations.i18MonthsTimeFrame">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open">
  <app-submit-row-buttons [form]="'editFanScoreCardForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="clubOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space esf-js-workingSpaceToggle -has-transition -is-open" (click)="clubOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
